import { ComboboxControlOption } from "@wordpress/components/build-types/combobox-control/types";
import { FontSize } from "@wordpress/components/build-types/font-size-picker/types";

export const numbersFontSizeOptions: FontSize[] = [
    { name: 'Small', size: 30, slug: 'small' },
    { name: 'Normal', size: 40, slug: 'normal' },
    { name: 'Big', size: 60, slug: 'big'
    }
];

export const numbersFontWightOptions: ComboboxControlOption[] = [
    { value: '400', label: 'Regular', },
    { value: '700', label: 'Bold',
    }
];

export const unitsFontSizeOptions: FontSize[] = [
    { name: 'Small', size: 10, slug: 'small' },
    { name: 'Normal', size: 13, slug: 'normal' },
    { name: 'Big', size: 16, slug: 'big' }
];

export const unitsFontWightOptions: ComboboxControlOption[] = [
    { value: '200', label: 'Thin', },
    { value: '400', label: 'Regular', },
    { value: '500', label: 'Semibold', },
    { value: '700', label: 'Bold', },
    { value: '900', label: 'Black' },
];

export const utcTimezones: ComboboxControlOption[] = [
    { label: 'UTC -12:00', value: 'UTC-12:00' },
    { label: 'UTC -11:30', value: 'UTC-11:30' },
    { label: 'UTC -11:00', value: 'UTC-11:00' },
    { label: 'UTC -10:30', value: 'UTC-10:30' },
    { label: 'UTC -10:00', value: 'UTC-10:00' },
    { label: 'UTC -9:30', value: 'UTC-9:30' },
    { label: 'UTC -9:00', value: 'UTC-9:00' },
    { label: 'UTC -8:30', value: 'UTC-8:30' },
    { label: 'UTC -8:00', value: 'UTC-8:00' },
    { label: 'UTC -7:30', value: 'UTC-7:30' },
    { label: 'UTC -7:00', value: 'UTC-7:00' },
    { label: 'UTC -6:30', value: 'UTC-6:30' },
    { label: 'UTC -6:00', value: 'UTC-6:00' },
    { label: 'UTC -5:30', value: 'UTC-5:30' },
    { label: 'UTC -5:00', value: 'UTC-5:00' },
    { label: 'UTC -4:30', value: 'UTC-4:30' },
    { label: 'UTC -4:00', value: 'UTC-4:00' },
    { label: 'UTC -3:30', value: 'UTC-3:30' },
    { label: 'UTC -3:00', value: 'UTC-3:00' },
    { label: 'UTC -2:30', value: 'UTC-2:30' },
    { label: 'UTC -2:00', value: 'UTC-2:00' },
    { label: 'UTC -1:30', value: 'UTC-1:30' },
    { label: 'UTC -1:00', value: 'UTC-1:00' },
    { label: 'UTC +0:00', value: 'UTC+0:00' },
  
    { label: 'UTC +1:00', value: 'UTC+1:00' },
    { label: 'UTC +1:30', value: 'UTC+1:30' },
    { label: 'UTC +2:00', value: 'UTC+2:00' },
    { label: 'UTC +2:30', value: 'UTC+2:30' },
    { label: 'UTC +3:00', value: 'UTC+3:00' },
    { label: 'UTC +3:30', value: 'UTC+3:30' },
    { label: 'UTC +4:00', value: 'UTC+4:00' },
    { label: 'UTC +4:30', value: 'UTC+4:30' },
    { label: 'UTC +5:00', value: 'UTC+5:00' },
    { label: 'UTC +5:30', value: 'UTC+5:30' },
    { label: 'UTC +6:00', value: 'UTC+6:00' },
    { label: 'UTC +6:30', value: 'UTC+6:30' },
    { label: 'UTC +7:00', value: 'UTC+7:00' },
    { label: 'UTC +7:30', value: 'UTC+7:30' },
    { label: 'UTC +8:00', value: 'UTC+8:00' },
    { label: 'UTC +8:30', value: 'UTC+8:30' },
    { label: 'UTC +9:00', value: 'UTC+9:00' },
    { label: 'UTC +9:30', value: 'UTC+9:30' },
    { label: 'UTC +10:00', value: 'UTC+:0010' },
    { label: 'UTC +10:30', value: 'UTC+10:30' },
    { label: 'UTC +11:00', value: 'UTC+11:00' },
    { label: 'UTC +11:30', value: 'UTC+11:30' },
    { label: 'UTC +12:00', value: 'UTC+12:00' },
];

export const timezoneListOptions: ComboboxControlOption[] = [
    { value: "Africa/Abidjan", label: "Africa/Abidjan (GMT)" },
    { value: "Africa/Accra", label: "Africa/Accra (GMT)" },
    { value: "Africa/Addis_Ababa", label: "Africa/Addis_Ababa (GMT+3)" },
    { value: "Africa/Algiers", label: "Africa/Algiers (GMT+1)" },
    { value: "Africa/Asmera", label: "Africa/Asmera (GMT+3)" },
    { value: "Africa/Bamako", label: "Africa/Bamako (GMT)" },
    { value: "Africa/Bangui", label: "Africa/Bangui (GMT+1)" },
    { value: "Africa/Banjul", label: "Africa/Banjul (GMT)" },
    { value: "Africa/Bissau", label: "Africa/Bissau (GMT)" },
    { value: "Africa/Blantyre", label: "Africa/Blantyre (GMT+2)" },
    { value: "Africa/Brazzaville", label: "Africa/Brazzaville (GMT+1)" },
    { value: "Africa/Bujumbura", label: "Africa/Bujumbura (GMT+2)" },
    { value: "Africa/Cairo", label: "Africa/Cairo (GMT+3)" },
    { value: "Africa/Casablanca", label: "Africa/Casablanca (GMT+1)" },
    { value: "Africa/Ceuta", label: "Africa/Ceuta (GMT+2)" },
    { value: "Africa/Conakry", label: "Africa/Conakry (GMT)" },
    { value: "Africa/Dakar", label: "Africa/Dakar (GMT)" },
    { value: "Africa/Dar_es_Salaam", label: "Africa/Dar_es_Salaam (GMT+3)" },
    { value: "Africa/Djibouti", label: "Africa/Djibouti (GMT+3)" },
    { value: "Africa/Douala", label: "Africa/Douala (GMT+1)" },
    { value: "Africa/El_Aaiun", label: "Africa/El_Aaiun (GMT+1)" },
    { value: "Africa/Freetown", label: "Africa/Freetown (GMT)" },
    { value: "Africa/Gaborone", label: "Africa/Gaborone (GMT+2)" },
    { value: "Africa/Harare", label: "Africa/Harare (GMT+2)" },
    { value: "Africa/Johannesburg", label: "Africa/Johannesburg (GMT+2)" },
    { value: "Africa/Juba", label: "Africa/Juba (GMT+2)" },
    { value: "Africa/Kampala", label: "Africa/Kampala (GMT+3)" },
    { value: "Africa/Khartoum", label: "Africa/Khartoum (GMT+2)" },
    { value: "Africa/Kigali", label: "Africa/Kigali (GMT+2)" },
    { value: "Africa/Kinshasa", label: "Africa/Kinshasa (GMT+1)" },
    { value: "Africa/Lagos", label: "Africa/Lagos (GMT+1)" },
    { value: "Africa/Libreville", label: "Africa/Libreville (GMT+1)" },
    { value: "Africa/Lome", label: "Africa/Lome (GMT)" },
    { value: "Africa/Luanda", label: "Africa/Luanda (GMT+1)" },
    { value: "Africa/Lubumbashi", label: "Africa/Lubumbashi (GMT+2)" },
    { value: "Africa/Lusaka", label: "Africa/Lusaka (GMT+2)" },
    { value: "Africa/Malabo", label: "Africa/Malabo (GMT+1)" },
    { value: "Africa/Maputo", label: "Africa/Maputo (GMT+2)" },
    { value: "Africa/Maseru", label: "Africa/Maseru (GMT+2)" },
    { value: "Africa/Mbabane", label: "Africa/Mbabane (GMT+2)" },
    { value: "Africa/Mogadishu", label: "Africa/Mogadishu (GMT+3)" },
    { value: "Africa/Monrovia", label: "Africa/Monrovia (GMT)" },
    { value: "Africa/Nairobi", label: "Africa/Nairobi (GMT+3)" },
    { value: "Africa/Ndjamena", label: "Africa/Ndjamena (GMT+1)" },
    { value: "Africa/Niamey", label: "Africa/Niamey (GMT+1)" },
    { value: "Africa/Nouakchott", label: "Africa/Nouakchott (GMT)" },
    { value: "Africa/Ouagadougou", label: "Africa/Ouagadougou (GMT)" },
    { value: "Africa/Porto-Novo", label: "Africa/Porto-Novo (GMT+1)" },
    { value: "Africa/Sao_Tome", label: "Africa/Sao_Tome (GMT)" },
    { value: "Africa/Tripoli", label: "Africa/Tripoli (GMT+2)" },
    { value: "Africa/Tunis", label: "Africa/Tunis (GMT+1)" },
    { value: "Africa/Windhoek", label: "Africa/Windhoek (GMT+2)" },
    { value: "America/Adak", label: "America/Adak (GMT-9)" },
    { value: "America/Anchorage", label: "America/Anchorage (GMT-8)" },
    { value: "America/Anguilla", label: "America/Anguilla (GMT-4)" },
    { value: "America/Antigua", label: "America/Antigua (GMT-4)" },
    { value: "America/Araguaina", label: "America/Araguaina (GMT-3)" },
    { value: "America/Argentina/La_Rioja", label: "America/Argentina/La_Rioja (GMT-3)" },
    { value: "America/Argentina/Rio_Gallegos", label: "America/Argentina/Rio_Gallegos (GMT-3)" },
    { value: "America/Argentina/Salta", label: "America/Argentina/Salta (GMT-3)" },
    { value: "America/Argentina/San_Juan", label: "America/Argentina/San_Juan (GMT-3)" },
    { value: "America/Argentina/San_Luis", label: "America/Argentina/San_Luis (GMT-3)" },
    { value: "America/Argentina/Tucuman", label: "America/Argentina/Tucuman (GMT-3)" },
    { value: "America/Argentina/Ushuaia", label: "America/Argentina/Ushuaia (GMT-3)" },
    { value: "America/Aruba", label: "America/Aruba (GMT-4)" },
    { value: "America/Asuncion", label: "America/Asuncion (GMT-4)" },
    { value: "America/Bahia", label: "America/Bahia (GMT-3)" },
    { value: "America/Bahia_Banderas", label: "America/Bahia_Banderas (GMT-6)" },
    { value: "America/Barbados", label: "America/Barbados (GMT-4)" },
    { value: "America/Belem", label: "America/Belem (GMT-3)" },
    { value: "America/Belize", label: "America/Belize (GMT-6)" },
    { value: "America/Blanc-Sablon", label: "America/Blanc-Sablon (GMT-4)" },
    { value: "America/Boa_Vista", label: "America/Boa_Vista (GMT-4)" },
    { value: "America/Bogota", label: "America/Bogota (GMT-5)" },
    { value: "America/Boise", label: "America/Boise (GMT-6)" },
    { value: "America/Buenos_Aires", label: "America/Buenos_Aires (GMT-3)" },
    { value: "America/Cambridge_Bay", label: "America/Cambridge_Bay (GMT-6)" },
    { value: "America/Campo_Grande", label: "America/Campo_Grande (GMT-4)" },
    { value: "America/Cancun", label: "America/Cancun (GMT-5)" },
    { value: "America/Caracas", label: "America/Caracas (GMT-4)" },
    { value: "America/Catamarca", label: "America/Catamarca (GMT-3)" },
    { value: "America/Cayenne", label: "America/Cayenne (GMT-3)" },
    { value: "America/Cayman", label: "America/Cayman (GMT-5)" },
    { value: "America/Chicago", label: "America/Chicago (GMT-5)" },
    { value: "America/Chihuahua", label: "America/Chihuahua (GMT-6)" },
    { value: "America/Ciudad_Juarez", label: "America/Ciudad_Juarez (GMT-6)" },
    { value: "America/Coral_Harbour", label: "America/Coral_Harbour (GMT-5)" },
    { value: "America/Cordoba", label: "America/Cordoba (GMT-3)" },
    { value: "America/Costa_Rica", label: "America/Costa_Rica (GMT-6)" },
    { value: "America/Creston", label: "America/Creston (GMT-7)" },
    { value: "America/Cuiaba", label: "America/Cuiaba (GMT-4)" },
    { value: "America/Curacao", label: "America/Curacao (GMT-4)" },
    { value: "America/Danmarkshavn", label: "America/Danmarkshavn (GMT)" },
    { value: "America/Dawson", label: "America/Dawson (GMT-7)" },
    { value: "America/Dawson_Creek", label: "America/Dawson_Creek (GMT-7)" },
    { value: "America/Denver", label: "America/Denver (GMT-6)" },
    { value: "America/Detroit", label: "America/Detroit (GMT-4)" },
    { value: "America/Dominica", label: "America/Dominica (GMT-4)" },
    { value: "America/Edmonton", label: "America/Edmonton (GMT-6)" },
    { value: "America/Eirunepe", label: "America/Eirunepe (GMT-5)" },
    { value: "America/El_Salvador", label: "America/El_Salvador (GMT-6)" },
    { value: "America/Fort_Nelson", label: "America/Fort_Nelson (GMT-7)" },
    { value: "America/Fortaleza", label: "America/Fortaleza (GMT-3)" },
    { value: "America/Glace_Bay", label: "America/Glace_Bay (GMT-3)" },
    { value: "America/Godthab", label: "America/Godthab (GMT-1)" },
    { value: "America/Goose_Bay", label: "America/Goose_Bay (GMT-3)" },
    { value: "America/Grand_Turk", label: "America/Grand_Turk (GMT-4)" },
    { value: "America/Grenada", label: "America/Grenada (GMT-4)" },
    { value: "America/Guadeloupe", label: "America/Guadeloupe (GMT-4)" },
    { value: "America/Guatemala", label: "America/Guatemala (GMT-6)" },
    { value: "America/Guayaquil", label: "America/Guayaquil (GMT-5)" },
    { value: "America/Guyana", label: "America/Guyana (GMT-4)" },
    { value: "America/Halifax", label: "America/Halifax (GMT-3)" },
    { value: "America/Havana", label: "America/Havana (GMT-4)" },
    { value: "America/Hermosillo", label: "America/Hermosillo (GMT-7)" },
    { value: "America/Indiana/Knox", label: "America/Indiana/Knox (GMT-5)" },
    { value: "America/Indiana/Marengo", label: "America/Indiana/Marengo (GMT-4)" },
    { value: "America/Indiana/Petersburg", label: "America/Indiana/Petersburg (GMT-4)" },
    { value: "America/Indiana/Tell_City", label: "America/Indiana/Tell_City (GMT-5)" },
    { value: "America/Indiana/Vevay", label: "America/Indiana/Vevay (GMT-4)" },
    { value: "America/Indiana/Vincennes", label: "America/Indiana/Vincennes (GMT-4)" },
    { value: "America/Indiana/Winamac", label: "America/Indiana/Winamac (GMT-4)" },
    { value: "America/Indianapolis", label: "America/Indianapolis (GMT-4)" },
    { value: "America/Inuvik", label: "America/Inuvik (GMT-6)" },
    { value: "America/Iqaluit", label: "America/Iqaluit (GMT-4)" },
    { value: "America/Jamaica", label: "America/Jamaica (GMT-5)" },
    { value: "America/Jujuy", label: "America/Jujuy (GMT-3)" },
    { value: "America/Juneau", label: "America/Juneau (GMT-8)" },
    { value: "America/Kentucky/Monticello", label: "America/Kentucky/Monticello (GMT-4)" },
    { value: "America/Kralendijk", label: "America/Kralendijk (GMT-4)" },
    { value: "America/La_Paz", label: "America/La_Paz (GMT-4)" },
    { value: "America/Lima", label: "America/Lima (GMT-5)" },
    { value: "America/Los_Angeles", label: "America/Los_Angeles (GMT-7)" },
    { value: "America/Louisville", label: "America/Louisville (GMT-4)" },
    { value: "America/Lower_Princes", label: "America/Lower_Princes (GMT-4)" },
    { value: "America/Maceio", label: "America/Maceio (GMT-3)" },
    { value: "America/Managua", label: "America/Managua (GMT-6)" },
    { value: "America/Manaus", label: "America/Manaus (GMT-4)" },
    { value: "America/Marigot", label: "America/Marigot (GMT-4)" },
    { value: "America/Martinique", label: "America/Martinique (GMT-4)" },
    { value: "America/Matamoros", label: "America/Matamoros (GMT-5)" },
    { value: "America/Mazatlan", label: "America/Mazatlan (GMT-7)" },
    { value: "America/Mendoza", label: "America/Mendoza (GMT-3)" },
    { value: "America/Menominee", label: "America/Menominee (GMT-5)" },
    { value: "America/Merida", label: "America/Merida (GMT-6)" },
    { value: "America/Metlakatla", label: "America/Metlakatla (GMT-8)" },
    { value: "America/Mexico_City", label: "America/Mexico_City (GMT-6)" },
    { value: "America/Miquelon", label: "America/Miquelon (GMT-2)" },
    { value: "America/Moncton", label: "America/Moncton (GMT-3)" },
    { value: "America/Monterrey", label: "America/Monterrey (GMT-6)" },
    { value: "America/Montevideo", label: "America/Montevideo (GMT-3)" },
    { value: "America/Montserrat", label: "America/Montserrat (GMT-4)" },
    { value: "America/Nassau", label: "America/Nassau (GMT-4)" },
    { value: "America/New_York", label: "America/New_York (GMT-4)" },
    { value: "America/Nome", label: "America/Nome (GMT-8)" },
    { value: "America/Noronha", label: "America/Noronha (GMT-2)" },
    { value: "America/North_Dakota/Beulah", label: "America/North_Dakota/Beulah (GMT-5)" },
    { value: "America/North_Dakota/Center", label: "America/North_Dakota/Center (GMT-5)" },
    { value: "America/North_Dakota/New_Salem", label: "America/North_Dakota/New_Salem (GMT-5)" },
    { value: "America/Ojinaga", label: "America/Ojinaga (GMT-5)" },
    { value: "America/Panama", label: "America/Panama (GMT-5)" },
    { value: "America/Paramaribo", label: "America/Paramaribo (GMT-3)" },
    { value: "America/Phoenix", label: "America/Phoenix (GMT-7)" },
    { value: "America/Port-au-Prince", label: "America/Port-au-Prince (GMT-4)" },
    { value: "America/Port_of_Spain", label: "America/Port_of_Spain (GMT-4)" },
    { value: "America/Porto_Velho", label: "America/Porto_Velho (GMT-4)" },
    { value: "America/Puerto_Rico", label: "America/Puerto_Rico (GMT-4)" },
    { value: "America/Punta_Arenas", label: "America/Punta_Arenas (GMT-3)" },
    { value: "America/Rankin_Inlet", label: "America/Rankin_Inlet (GMT-5)" },
    { value: "America/Recife", label: "America/Recife (GMT-3)" },
    { value: "America/Regina", label: "America/Regina (GMT-6)" },
    { value: "America/Resolute", label: "America/Resolute (GMT-5)" },
    { value: "America/Rio_Branco", label: "America/Rio_Branco (GMT-5)" },
    { value: "America/Santarem", label: "America/Santarem (GMT-3)" },
    { value: "America/Santiago", label: "America/Santiago (GMT-4)" },
    { value: "America/Santo_Domingo", label: "America/Santo_Domingo (GMT-4)" },
    { value: "America/Sao_Paulo", label: "America/Sao_Paulo (GMT-3)" },
    { value: "America/Scoresbysund", label: "America/Scoresbysund (GMT-1)" },
    { value: "America/Sitka", label: "America/Sitka (GMT-8)" },
    { value: "America/St_Barthelemy", label: "America/St_Barthelemy (GMT-4)" },
    { value: "America/St_Johns", label: "America/St_Johns (GMT-2:30)" },
    { value: "America/St_Kitts", label: "America/St_Kitts (GMT-4)" },
    { value: "America/St_Lucia", label: "America/St_Lucia (GMT-4)" },
    { value: "America/St_Thomas", label: "America/St_Thomas (GMT-4)" },
    { value: "America/St_Vincent", label: "America/St_Vincent (GMT-4)" },
    { value: "America/Swift_Current", label: "America/Swift_Current (GMT-6)" },
    { value: "America/Tegucigalpa", label: "America/Tegucigalpa (GMT-6)" },
    { value: "America/Thule", label: "America/Thule (GMT-3)" },
    { value: "America/Tijuana", label: "America/Tijuana (GMT-7)" },
    { value: "America/Toronto", label: "America/Toronto (GMT-4)" },
    { value: "America/Tortola", label: "America/Tortola (GMT-4)" },
    { value: "America/Vancouver", label: "America/Vancouver (GMT-7)" },
    { value: "America/Whitehorse", label: "America/Whitehorse (GMT-7)" },
    { value: "America/Winnipeg", label: "America/Winnipeg (GMT-5)" },
    { value: "America/Yakutat", label: "America/Yakutat (GMT-8)" },
    { value: "Antarctica/Casey", label: "Antarctica/Casey (GMT+8)" },
    { value: "Antarctica/Davis", label: "Antarctica/Davis (GMT+7)" },
    { value: "Antarctica/DumontDUrville", label: "Antarctica/DumontDUrville (GMT+10)" },
    { value: "Antarctica/Macquarie", label: "Antarctica/Macquarie (GMT+10)" },
    { value: "Antarctica/Mawson", label: "Antarctica/Mawson (GMT+5)" },
    { value: "Antarctica/McMurdo", label: "Antarctica/McMurdo (GMT+12)" },
    { value: "Antarctica/Palmer", label: "Antarctica/Palmer (GMT-3)" },
    { value: "Antarctica/Rothera", label: "Antarctica/Rothera (GMT-3)" },
    { value: "Antarctica/Syowa", label: "Antarctica/Syowa (GMT+3)" },
    { value: "Antarctica/Troll", label: "Antarctica/Troll (GMT+2)" },
    { value: "Antarctica/Vostok", label: "Antarctica/Vostok (GMT+5)" },
    { value: "Arctic/Longyearbyen", label: "Arctic/Longyearbyen (GMT+2)" },
    { value: "Asia/Aden", label: "Asia/Aden (GMT+3)" },
    { value: "Asia/Almaty", label: "Asia/Almaty (GMT+5)" },
    { value: "Asia/Amman", label: "Asia/Amman (GMT+3)" },
    { value: "Asia/Anadyr", label: "Asia/Anadyr (GMT+12)" },
    { value: "Asia/Aqtau", label: "Asia/Aqtau (GMT+5)" },
    { value: "Asia/Aqtobe", label: "Asia/Aqtobe (GMT+5)" },
    { value: "Asia/Ashgabat", label: "Asia/Ashgabat (GMT+5)" },
    { value: "Asia/Atyrau", label: "Asia/Atyrau (GMT+5)" },
    { value: "Asia/Baghdad", label: "Asia/Baghdad (GMT+3)" },
    { value: "Asia/Bahrain", label: "Asia/Bahrain (GMT+3)" },
    { value: "Asia/Baku", label: "Asia/Baku (GMT+4)" },
    { value: "Asia/Bangkok", label: "Asia/Bangkok (GMT+7)" },
    { value: "Asia/Barnaul", label: "Asia/Barnaul (GMT+7)" },
    { value: "Asia/Beirut", label: "Asia/Beirut (GMT+3)" },
    { value: "Asia/Bishkek", label: "Asia/Bishkek (GMT+6)" },
    { value: "Asia/Brunei", label: "Asia/Brunei (GMT+8)" },
    { value: "Asia/Calcutta", label: "Asia/Calcutta (GMT+5:30)" },
    { value: "Asia/Chita", label: "Asia/Chita (GMT+9)" },
    { value: "Asia/Choibalsan", label: "Asia/Choibalsan (GMT+8)" },
    { value: "Asia/Colombo", label: "Asia/Colombo (GMT+5:30)" },
    { value: "Asia/Damascus", label: "Asia/Damascus (GMT+3)" },
    { value: "Asia/Dhaka", label: "Asia/Dhaka (GMT+6)" },
    { value: "Asia/Dili", label: "Asia/Dili (GMT+9)" },
    { value: "Asia/Dubai", label: "Asia/Dubai (GMT+4)" },
    { value: "Asia/Dushanbe", label: "Asia/Dushanbe (GMT+5)" },
    { value: "Asia/Famagusta", label: "Asia/Famagusta (GMT+3)" },
    { value: "Asia/Gaza", label: "Asia/Gaza (GMT+3)" },
    { value: "Asia/Hebron", label: "Asia/Hebron (GMT+3)" },
    { value: "Asia/Hong_Kong", label: "Asia/Hong_Kong (GMT+8)" },
    { value: "Asia/Hovd", label: "Asia/Hovd (GMT+7)" },
    { value: "Asia/Irkutsk", label: "Asia/Irkutsk (GMT+8)" },
    { value: "Asia/Jakarta", label: "Asia/Jakarta (GMT+7)" },
    { value: "Asia/Jayapura", label: "Asia/Jayapura (GMT+9)" },
    { value: "Asia/Jerusalem", label: "Asia/Jerusalem (GMT+3)" },
    { value: "Asia/Kabul", label: "Asia/Kabul (GMT+4:30)" },
    { value: "Asia/Kamchatka", label: "Asia/Kamchatka (GMT+12)" },
    { value: "Asia/Karachi", label: "Asia/Karachi (GMT+5)" },
    { value: "Asia/Katmandu", label: "Asia/Katmandu (GMT+5:45)" },
    { value: "Asia/Khandyga", label: "Asia/Khandyga (GMT+9)" },
    { value: "Asia/Krasnoyarsk", label: "Asia/Krasnoyarsk (GMT+7)" },
    { value: "Asia/Kuala_Lumpur", label: "Asia/Kuala_Lumpur (GMT+8)" },
    { value: "Asia/Kuching", label: "Asia/Kuching (GMT+8)" },
    { value: "Asia/Kuwait", label: "Asia/Kuwait (GMT+3)" },
    { value: "Asia/Macau", label: "Asia/Macau (GMT+8)" },
    { value: "Asia/Magadan", label: "Asia/Magadan (GMT+11)" },
    { value: "Asia/Makassar", label: "Asia/Makassar (GMT+8)" },
    { value: "Asia/Manila", label: "Asia/Manila (GMT+8)" },
    { value: "Asia/Muscat", label: "Asia/Muscat (GMT+4)" },
    { value: "Asia/Nicosia", label: "Asia/Nicosia (GMT+3)" },
    { value: "Asia/Novokuznetsk", label: "Asia/Novokuznetsk (GMT+7)" },
    { value: "Asia/Novosibirsk", label: "Asia/Novosibirsk (GMT+7)" },
    { value: "Asia/Omsk", label: "Asia/Omsk (GMT+6)" },
    { value: "Asia/Oral", label: "Asia/Oral (GMT+5)" },
    { value: "Asia/Phnom_Penh", label: "Asia/Phnom_Penh (GMT+7)" },
    { value: "Asia/Pontianak", label: "Asia/Pontianak (GMT+7)" },
    { value: "Asia/Pyongyang", label: "Asia/Pyongyang (GMT+9)" },
    { value: "Asia/Qatar", label: "Asia/Qatar (GMT+3)" },
    { value: "Asia/Qostanay", label: "Asia/Qostanay (GMT+5)" },
    { value: "Asia/Qyzylorda", label: "Asia/Qyzylorda (GMT+5)" },
    { value: "Asia/Rangoon", label: "Asia/Rangoon (GMT+6:30)" },
    { value: "Asia/Riyadh", label: "Asia/Riyadh (GMT+3)" },
    { value: "Asia/Saigon", label: "Asia/Saigon (GMT+7)" },
    { value: "Asia/Sakhalin", label: "Asia/Sakhalin (GMT+11)" },
    { value: "Asia/Samarkand", label: "Asia/Samarkand (GMT+5)" },
    { value: "Asia/Seoul", label: "Asia/Seoul (GMT+9)" },
    { value: "Asia/Shanghai", label: "Asia/Shanghai (GMT+8)" },
    { value: "Asia/Singapore", label: "Asia/Singapore (GMT+8)" },
    { value: "Asia/Srednekolymsk", label: "Asia/Srednekolymsk (GMT+11)" },
    { value: "Asia/Taipei", label: "Asia/Taipei (GMT+8)" },
    { value: "Asia/Tashkent", label: "Asia/Tashkent (GMT+5)" },
    { value: "Asia/Tbilisi", label: "Asia/Tbilisi (GMT+4)" },
    { value: "Asia/Tehran", label: "Asia/Tehran (GMT+3:30)" },
    { value: "Asia/Thimphu", label: "Asia/Thimphu (GMT+6)" },
    { value: "Asia/Tokyo", label: "Asia/Tokyo (GMT+9)" },
    { value: "Asia/Tomsk", label: "Asia/Tomsk (GMT+7)" },
    { value: "Asia/Ulaanbaatar", label: "Asia/Ulaanbaatar (GMT+8)" },
    { value: "Asia/Urumqi", label: "Asia/Urumqi (GMT+6)" },
    { value: "Asia/Ust-Nera", label: "Asia/Ust-Nera (GMT+10)" },
    { value: "Asia/Vientiane", label: "Asia/Vientiane (GMT+7)" },
    { value: "Asia/Vladivostok", label: "Asia/Vladivostok (GMT+10)" },
    { value: "Asia/Yakutsk", label: "Asia/Yakutsk (GMT+9)" },
    { value: "Asia/Yekaterinburg", label: "Asia/Yekaterinburg (GMT+5)" },
    { value: "Asia/Yerevan", label: "Asia/Yerevan (GMT+4)" },
    { value: "Atlantic/Azores", label: "Atlantic/Azores (GMT)" },
    { value: "Atlantic/Bermuda", label: "Atlantic/Bermuda (GMT-3)" },
    { value: "Atlantic/Canary", label: "Atlantic/Canary (GMT+1)" },
    { value: "Atlantic/Cape_Verde", label: "Atlantic/Cape_Verde (GMT-1)" },
    { value: "Atlantic/Faeroe", label: "Atlantic/Faeroe (GMT+1)" },
    { value: "Atlantic/Madeira", label: "Atlantic/Madeira (GMT+1)" },
    { value: "Atlantic/Reykjavik", label: "Atlantic/Reykjavik (GMT)" },
    { value: "Atlantic/South_Georgia", label: "Atlantic/South_Georgia (GMT-2)" },
    { value: "Atlantic/St_Helena", label: "Atlantic/St_Helena (GMT)" },
    { value: "Atlantic/Stanley", label: "Atlantic/Stanley (GMT-3)" },
    { value: "Australia/Adelaide", label: "Australia/Adelaide (GMT+9:30)" },
    { value: "Australia/Brisbane", label: "Australia/Brisbane (GMT+10)" },
    { value: "Australia/Broken_Hill", label: "Australia/Broken_Hill (GMT+9:30)" },
    { value: "Australia/Darwin", label: "Australia/Darwin (GMT+9:30)" },
    { value: "Australia/Eucla", label: "Australia/Eucla (GMT+8:45)" },
    { value: "Australia/Hobart", label: "Australia/Hobart (GMT+10)" },
    { value: "Australia/Lindeman", label: "Australia/Lindeman (GMT+10)" },
    { value: "Australia/Lord_Howe", label: "Australia/Lord_Howe (GMT+10:30)" },
    { value: "Australia/Melbourne", label: "Australia/Melbourne (GMT+10)" },
    { value: "Australia/Perth", label: "Australia/Perth (GMT+8)" },
    { value: "Australia/Sydney", label: "Australia/Sydney (GMT+10)" },
    { value: "Europe/Amsterdam", label: "Europe/Amsterdam (GMT+2)" },
    { value: "Europe/Andorra", label: "Europe/Andorra (GMT+2)" },
    { value: "Europe/Astrakhan", label: "Europe/Astrakhan (GMT+4)" },
    { value: "Europe/Athens", label: "Europe/Athens (GMT+3)" },
    { value: "Europe/Belgrade", label: "Europe/Belgrade (GMT+2)" },
    { value: "Europe/Berlin", label: "Europe/Berlin (GMT+2)" },
    { value: "Europe/Bratislava", label: "Europe/Bratislava (GMT+2)" },
    { value: "Europe/Brussels", label: "Europe/Brussels (GMT+2)" },
    { value: "Europe/Bucharest", label: "Europe/Bucharest (GMT+3)" },
    { value: "Europe/Budapest", label: "Europe/Budapest (GMT+2)" },
    { value: "Europe/Busingen", label: "Europe/Busingen (GMT+2)" },
    { value: "Europe/Chisinau", label: "Europe/Chisinau (GMT+3)" },
    { value: "Europe/Copenhagen", label: "Europe/Copenhagen (GMT+2)" },
    { value: "Europe/Dublin", label: "Europe/Dublin (GMT+1)" },
    { value: "Europe/Gibraltar", label: "Europe/Gibraltar (GMT+2)" },
    { value: "Europe/Guernsey", label: "Europe/Guernsey (GMT+1)" },
    { value: "Europe/Helsinki", label: "Europe/Helsinki (GMT+3)" },
    { value: "Europe/Isle_of_Man", label: "Europe/Isle_of_Man (GMT+1)" },
    { value: "Europe/Istanbul", label: "Europe/Istanbul (GMT+3)" },
    { value: "Europe/Jersey", label: "Europe/Jersey (GMT+1)" },
    { value: "Europe/Kaliningrad", label: "Europe/Kaliningrad (GMT+2)" },
    { value: "Europe/Kiev", label: "Europe/Kiev (GMT+3)" },
    { value: "Europe/Kirov", label: "Europe/Kirov (GMT+3)" },
    { value: "Europe/Lisbon", label: "Europe/Lisbon (GMT+1)" },
    { value: "Europe/Ljubljana", label: "Europe/Ljubljana (GMT+2)" },
    { value: "Europe/London", label: "Europe/London (GMT+1)" },
    { value: "Europe/Luxembourg", label: "Europe/Luxembourg (GMT+2)" },
    { value: "Europe/Madrid", label: "Europe/Madrid (GMT+2)" },
    { value: "Europe/Malta", label: "Europe/Malta (GMT+2)" },
    { value: "Europe/Mariehamn", label: "Europe/Mariehamn (GMT+3)" },
    { value: "Europe/Minsk", label: "Europe/Minsk (GMT+3)" },
    { value: "Europe/Monaco", label: "Europe/Monaco (GMT+2)" },
    { value: "Europe/Moscow", label: "Europe/Moscow (GMT+3)" },
    { value: "Europe/Oslo", label: "Europe/Oslo (GMT+2)" },
    { value: "Europe/Paris", label: "Europe/Paris (GMT+2)" },
    { value: "Europe/Podgorica", label: "Europe/Podgorica (GMT+2)" },
    { value: "Europe/Prague", label: "Europe/Prague (GMT+2)" },
    { value: "Europe/Riga", label: "Europe/Riga (GMT+3)" },
    { value: "Europe/Rome", label: "Europe/Rome (GMT+2)" },
    { value: "Europe/Samara", label: "Europe/Samara (GMT+4)" },
    { value: "Europe/San_Marino", label: "Europe/San_Marino (GMT+2)" },
    { value: "Europe/Sarajevo", label: "Europe/Sarajevo (GMT+2)" },
    { value: "Europe/Saratov", label: "Europe/Saratov (GMT+4)" },
    { value: "Europe/Simferopol", label: "Europe/Simferopol (GMT+3)" },
    { value: "Europe/Skopje", label: "Europe/Skopje (GMT+2)" },
    { value: "Europe/Sofia", label: "Europe/Sofia (GMT+3)" },
    { value: "Europe/Stockholm", label: "Europe/Stockholm (GMT+2)" },
    { value: "Europe/Tallinn", label: "Europe/Tallinn (GMT+3)" },
    { value: "Europe/Tirane", label: "Europe/Tirane (GMT+2)" },
    { value: "Europe/Ulyanovsk", label: "Europe/Ulyanovsk (GMT+4)" },
    { value: "Europe/Vaduz", label: "Europe/Vaduz (GMT+2)" },
    { value: "Europe/Vatican", label: "Europe/Vatican (GMT+2)" },
    { value: "Europe/Vienna", label: "Europe/Vienna (GMT+2)" },
    { value: "Europe/Vilnius", label: "Europe/Vilnius (GMT+3)" },
    { value: "Europe/Volgograd", label: "Europe/Volgograd (GMT+3)" },
    { value: "Europe/Warsaw", label: "Europe/Warsaw (GMT+2)" },
    { value: "Europe/Zagreb", label: "Europe/Zagreb (GMT+2)" },
    { value: "Europe/Zurich", label: "Europe/Zurich (GMT+2)" },
    { value: "Indian/Antananarivo", label: "Indian/Antananarivo (GMT+3)" },
    { value: "Indian/Chagos", label: "Indian/Chagos (GMT+6)" },
    { value: "Indian/Christmas", label: "Indian/Christmas (GMT+7)" },
    { value: "Indian/Cocos", label: "Indian/Cocos (GMT+6:30)" },
    { value: "Indian/Comoro", label: "Indian/Comoro (GMT+3)" },
    { value: "Indian/Kerguelen", label: "Indian/Kerguelen (GMT+5)" },
    { value: "Indian/Mahe", label: "Indian/Mahe (GMT+4)" },
    { value: "Indian/Maldives", label: "Indian/Maldives (GMT+5)" },
    { value: "Indian/Mauritius", label: "Indian/Mauritius (GMT+4)" },
    { value: "Indian/Mayotte", label: "Indian/Mayotte (GMT+3)" },
    { value: "Indian/Reunion", label: "Indian/Reunion (GMT+4)" },
    { value: "Pacific/Apia", label: "Pacific/Apia (GMT+13)" },
    { value: "Pacific/Auckland", label: "Pacific/Auckland (GMT+12)" },
    { value: "Pacific/Bougainville", label: "Pacific/Bougainville (GMT+11)" },
    { value: "Pacific/Chatham", label: "Pacific/Chatham (GMT+12:45)" },
    { value: "Pacific/Easter", label: "Pacific/Easter (GMT-6)" },
    { value: "Pacific/Efate", label: "Pacific/Efate (GMT+11)" },
    { value: "Pacific/Enderbury", label: "Pacific/Enderbury (GMT+13)" },
    { value: "Pacific/Fakaofo", label: "Pacific/Fakaofo (GMT+13)" },
    { value: "Pacific/Fiji", label: "Pacific/Fiji (GMT+12)" },
    { value: "Pacific/Funafuti", label: "Pacific/Funafuti (GMT+12)" },
    { value: "Pacific/Galapagos", label: "Pacific/Galapagos (GMT-6)" },
    { value: "Pacific/Gambier", label: "Pacific/Gambier (GMT-9)" },
    { value: "Pacific/Guadalcanal", label: "Pacific/Guadalcanal (GMT+11)" },
    { value: "Pacific/Guam", label: "Pacific/Guam (GMT+10)" },
    { value: "Pacific/Honolulu", label: "Pacific/Honolulu (GMT-10)" },
    { value: "Pacific/Kiritimati", label: "Pacific/Kiritimati (GMT+14)" },
    { value: "Pacific/Kosrae", label: "Pacific/Kosrae (GMT+11)" },
    { value: "Pacific/Kwajalein", label: "Pacific/Kwajalein (GMT+12)" },
    { value: "Pacific/Majuro", label: "Pacific/Majuro (GMT+12)" },
    { value: "Pacific/Marquesas", label: "Pacific/Marquesas (GMT-9:30)" },
    { value: "Pacific/Midway", label: "Pacific/Midway (GMT-11)" },
    { value: "Pacific/Nauru", label: "Pacific/Nauru (GMT+12)" },
    { value: "Pacific/Niue", label: "Pacific/Niue (GMT-11)" },
    { value: "Pacific/Norfolk", label: "Pacific/Norfolk (GMT+11)" },
    { value: "Pacific/Noumea", label: "Pacific/Noumea (GMT+11)" },
    { value: "Pacific/Pago_Pago", label: "Pacific/Pago_Pago (GMT-11)" },
    { value: "Pacific/Palau", label: "Pacific/Palau (GMT+9)" },
    { value: "Pacific/Pitcairn", label: "Pacific/Pitcairn (GMT-8)" },
    { value: "Pacific/Ponape", label: "Pacific/Ponape (GMT+11)" },
    { value: "Pacific/Port_Moresby", label: "Pacific/Port_Moresby (GMT+10)" },
    { value: "Pacific/Rarotonga", label: "Pacific/Rarotonga (GMT-10)" },
    { value: "Pacific/Saipan", label: "Pacific/Saipan (GMT+10)" },
    { value: "Pacific/Tahiti", label: "Pacific/Tahiti (GMT-10)" },
    { value: "Pacific/Tarawa", label: "Pacific/Tarawa (GMT+12)" },
    { value: "Pacific/Tongatapu", label: "Pacific/Tongatapu (GMT+13)" },
    { value: "Pacific/Truk", label: "Pacific/Truk (GMT+10)" },
    { value: "Pacific/Wake", label: "Pacific/Wake (GMT+12)" },
    { value: "Pacific/Wallis", label: "Pacific/Wallis (GMT+12)" },

    ...utcTimezones
]